import { useEffect } from "react";

const useMessageHistoryTracking = ({ messages, setIsViewingHistory, chatPanelRef }) => {
  useEffect(() => {
    const lastMessage = messages.length > 0 ? messages[messages.length - 1] : null;
    if (lastMessage && lastMessage.type) {
      setIsViewingHistory(false);
    }
  }, [messages, setIsViewingHistory]);

  useEffect(() => {
    const messageContainer = chatPanelRef.current;
    if (!messageContainer) return;

    let rafId = null;
    const handleScroll = () => {
      if (rafId !== null) return;
      rafId = requestAnimationFrame(() => {
        rafId = null;
        const { scrollTop, scrollHeight, clientHeight } = messageContainer;
        const isNearBottom = scrollHeight - scrollTop - clientHeight < 100;
        const nextIsViewingHistory = !isNearBottom;
        setIsViewingHistory((prev) => (prev === nextIsViewingHistory ? prev : nextIsViewingHistory));
      });
    };

    messageContainer.addEventListener("scroll", handleScroll, { passive: true });
    return () => {
      if (rafId !== null) {
        cancelAnimationFrame(rafId);
      }
      messageContainer.removeEventListener("scroll", handleScroll);
    };
  }, [chatPanelRef, setIsViewingHistory]);
};

export default useMessageHistoryTracking;
